import h from "css-tree/parser";
const o = " ", c = "", N = ":", $ = ";", L = '"', x = "(", g = ")", d = "[", ee = "]", H = "{", V = "}", te = "{}", W = ",", Z = "Atrule", z = "Rule", F = "Block", G = "SelectorList", I = "Selector", Y = "Declaration", B = "Operator";
function C(y) {
  return /[A-Z]/.test(y) ? y.toLowerCase() : y;
}
function re(y, { minify: P = !1 } = {}) {
  let O = [], v = h(y, {
    positions: !0,
    parseAtrulePrelude: !1,
    parseCustomProperty: !0,
    parseValue: !0,
    onComment: (n, e) => {
      O.push(e.start.offset, e.end.offset);
    }
  });
  const u = P ? c : `
`, p = P ? c : o, Q = P ? c : $;
  let s = 0;
  function a(n) {
    return P ? c : "	".repeat(n);
  }
  function A(n) {
    let e = n.loc;
    return e ? y.slice(e.start.offset, e.end.offset) : c;
  }
  function b(n) {
    return /** @type {import('css-tree').CssLocation} */ n.loc.start.offset;
  }
  function E(n) {
    return /** @type {import('css-tree').CssLocation} */ n.loc.end.offset;
  }
  function m(n, e) {
    if (P || n === void 0 || e === void 0)
      return c;
    let t = "";
    for (let r = 0; r < O.length; r += 2) {
      let l = O[r];
      if (l === void 0 || l < n) continue;
      let f = O[r + 1];
      if (f === void 0 || f > e) break;
      t.length > 0 && (t += u + a(s)), t += y.slice(l, f);
    }
    return t;
  }
  function w(n) {
    let e, t = n.prelude, r = n.block;
    t.type === G && (e = j(t));
    let l = m(E(t), b(r));
    return l && (e += u + a(s) + l), r.type === F && (e += M(r)), e;
  }
  function j(n) {
    let e = c;
    return n.children.forEach((t, r) => {
      t.type === I && (e += a(s) + S(t)), r.next !== null && (e += W + u);
      let l = r.next !== null ? b(r.next.data) : E(n), f = m(E(t), l);
      f && (e += a(s) + f + u);
    }), e;
  }
  function S(n) {
    let e = c;
    return (n.children || []).forEach((r) => {
      switch (r.type) {
        case "TypeSelector": {
          e += C(r.name);
          break;
        }
        case "Combinator": {
          e += o, r.name !== " " && (e += r.name + o);
          break;
        }
        case "PseudoClassSelector":
        case "PseudoElementSelector": {
          e += N;
          let l = C(r.name);
          (l === "before" || l === "after" || r.type === "PseudoElementSelector") && (e += N), e += l, r.children && (e += x + S(r) + g);
          break;
        }
        case G: {
          r.children.forEach((l, f) => {
            l.type === I && (e += S(l)), f.next && f.next.data.type === I && (e += W + p);
          });
          break;
        }
        case "Nth": {
          let l = r.nth;
          if (l)
            if (l.type === "AnPlusB") {
              let f = l.a, i = l.b;
              f !== null && (e += f + "n"), f !== null && i !== null && (e += o), i !== null && (f !== null && !i.startsWith("-") && (e += "+" + o), e += i);
            } else
              e += A(l);
          r.selector !== null && (e += o + "of" + o + S(r.selector));
          break;
        }
        case "AttributeSelector": {
          e += d, e += r.name.name, r.matcher && r.value && (e += r.matcher, e += L, r.value.type === "String" ? e += r.value.value : r.value.type === "Identifier" && (e += r.value.name), e += L), r.flags && (e += o + r.flags), e += ee;
          break;
        }
        default: {
          e += A(r);
          break;
        }
      }
    }), e;
  }
  function M(n) {
    let e = n.children, t = p;
    if (e.isEmpty) {
      let f = m(b(n), E(n));
      return f ? (t += H + u, t += a(s + 1) + f, t += u + a(s) + V, t) : t + te;
    }
    t += H + u, s++;
    let r = m(b(n), b(
      /** @type {import('css-tree').CssNode} */
      e.first
    ));
    r && (t += a(s) + r + u), e.forEach((f, i) => {
      if (i.prev !== null) {
        let D = m(E(i.prev.data), b(f));
        D && (t += a(s) + D + u);
      }
      f.type === Y ? (t += J(f), i.next === null ? t += Q : t += $) : (i.prev !== null && i.prev.data.type === Y && (t += u), f.type === z ? t += w(f) : f.type === Z ? t += K(f) : t += k(f, s)), i.next !== null && (t += u, f.type !== Y && (t += u));
    });
    let l = m(E(
      /** @type {import('css-tree').CssNode} */
      e.last
    ), E(n));
    return l && (t += u + a(s) + l), s--, t += u + a(s) + V, t;
  }
  function K(n) {
    let e = a(s) + "@", t = n.prelude, r = n.block;
    return e += C(n.name), t !== null && (e += o + q(t)), r === null ? e += $ : r.type === F && (e += M(r)), e;
  }
  function q(n) {
    let e = A(n);
    return e.replace(/\s*([:,])/g, e.toLowerCase().includes("selector(") ? "$1" : "$1 ").replace(/\)([a-zA-Z])/g, ") $1").replace(/\s*(=>|<=)\s*/g, " $1 ").replace(/([^<>=\s])([<>])([^<>=\s])/g, `$1${p}$2${p}$3`).replace(/\s+/g, p).replace(/calc\(\s*([^()+\-*/]+)\s*([*/+-])\s*([^()+\-*/]+)\s*\)/g, (t, r, l, f) => {
      let i = l === "+" || l === "-" ? o : p;
      return `calc(${r.trim()}${i}${l}${i}${f.trim()})`;
    }).replace(/selector|url|supports|layer\(/ig, (t) => C(t));
  }
  function J(n) {
    let e = n.property;
    e.charCodeAt(0) === 45 && e.charCodeAt(1) === 45 || (e = C(e));
    let t = U(n.value);
    return e === "font" && (t = t.replace(/\s*\/\s*/, "/")), t === c && P && (t += o), n.important === !0 ? t += p + "!important" : typeof n.important == "string" && (t += p + "!" + C(n.important)), a(s) + e + N + p + t;
  }
  function R(n) {
    let e = c;
    return n.forEach((t, r) => {
      t.type === "Identifier" ? e += t.name : t.type === "Function" ? e += C(t.name) + x + R(t.children) + g : t.type === "Dimension" ? e += t.value + C(t.unit) : t.type === "Value" ? e += U(t) : t.type === B ? e += X(t) : t.type === "Parentheses" ? e += x + R(t.children) + g : t.type === "Url" ? e += "url(" + L + t.value + L + g : e += A(t), t.type !== B && r.next !== null && r.next.data.type !== B && (e += o);
    }), e;
  }
  function X(n) {
    let e = c, t = n.value.trim(), r = t.charCodeAt(0);
    return r === 43 || r === 45 ? e += o : r !== 44 && (e += p), e += t, r === 43 || r === 45 ? e += o : e += p, e;
  }
  function U(n) {
    return n.type === "Raw" ? k(n, 0) : R(n.children);
  }
  function k(n, e) {
    return a(e) + A(n).trim();
  }
  let T = v.children, _ = c;
  if (T.first) {
    let n = m(0, b(T.first));
    n && (_ += n + u), T.forEach((t, r) => {
      if (t.type === z ? _ += w(t) : t.type === Z ? _ += K(t) : _ += k(t, s), r.next !== null) {
        _ += u;
        let l = m(E(t), b(r.next.data));
        l && (_ += a(s) + l), _ += u;
      }
    });
    let e = m(E(
      /** @type {import('css-tree').CssNode} */
      T.last
    ), E(v));
    e && (_ += u + e);
  } else
    _ += m(0, E(v));
  return _;
}
function le(y) {
  return re(y, { minify: !0 });
}
export {
  re as format,
  le as minify
};
